"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var lesson_plans_html_1 = __importDefault(require("./lesson-plans.html"));
var lesson_plans_controller_1 = __importDefault(require("./lesson-plans.controller"));
var create_lesson_plan_module_1 = __importDefault(require("./create-lesson-plan/create-lesson-plan.module"));
var edit_lesson_plan_module_1 = __importDefault(require("./edit-lesson-plan/edit-lesson-plan.module"));
function getCourseTypes(CourseTypesModel) {
    return CourseTypesModel.get().then(function (response) {
        return response.courseTypes;
    });
}
getCourseTypes.$inject = ["CourseTypesModel"];
function getSessionTypes(DriveSessionTypesModel) {
    return DriveSessionTypesModel.get().then(function (response) {
        return response.sessionTypes;
    });
}
getSessionTypes.$inject = ["DriveSessionTypesModel"];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.lessonplans", {
        url: "/workflows",
        controller: "LessonPlansController",
        controllerAs: "vm",
        template: lesson_plans_html_1.default,
        resolve: {
            courseTypes: getCourseTypes,
            sessionTypes: getSessionTypes,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.lessonplans", [
    create_lesson_plan_module_1.default.name,
    edit_lesson_plan_module_1.default.name,
])
    .config(config)
    .controller("LessonPlansController", lesson_plans_controller_1.default);
